export default __webpack_public_path__ + "static/media/favicon.28952190.png";